module.exports = __webpack_public_path__ + "static/logo-msql-82cbf523e46e642f6199526b36763780.png";